import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { BackendApiService } from "./backend-api.service";

@Injectable({
  providedIn: "root",
})
export class EnergyMeterService {
  public totalMeter = 0;
  private meterData = new BehaviorSubject(null);
  public meterDataObs = this.meterData.asObservable();

  private meterSrvData = new BehaviorSubject(null);
  public meterSrvDataObs = this.meterSrvData.asObservable();

  constructor(private service: BackendApiService) {}
  setMeterData(data) {
    this.meterData.next(data);
  }

  setMeterServiceData(data) {
    this.meterSrvData.next(data);
  }

  setMetersCount(count) {
    this.totalMeter = count;
  }
  getMetersCount() {
    return this.totalMeter;
  }

  getOperationalKPIs(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          if (data.data.code == 200 && data.data.status == "success") {
            resolve(data.data.body);
          } else {
            this.service.showError("Error fetching operational KPIs");
            reject(null);
          }
        })
        .catch((err) => {
          this.service.showError("Error fetching operational KPIs");
          reject(null);
        });
    });
  }
  fetchServiceRecordData(endpoint: string) {
    return new Promise((resolve, reject) => {
      this.service
        .getDataV2(endpoint)
        .then((data: any) => {
          if (data.data.code == 200 && data.data.status == "success") {
            resolve(data.data.body);
          } else {
            this.service.showError("Error fetching service data");
            reject(null);
          }
        })
        .catch((err) => {
          this.service.showError("Error fetching service data");
          reject(null);
        });
    });
  }

  updateServiceRecordData(endpoint, data) {
    console.log(data);
    return new Promise((resolve, reject) => {
      this.service
        .postData(endpoint, data)
        .then((res: any) => {
          if (res.data.code == 200 && res.data.status == "success") {
            this.service.showSuccess("Service data updated successfully");
            resolve({ isSuccess: true });
          } else {
            this.service.showError("Error updating service data");
            reject({ isSuccess: false });
          }
        })
        .catch((err) => {
          this.service.showError("Error updating service data");
          reject({ isSuccess: false });
        });
    });
  }
  updateOFSData(endpoint,data) {
    return new Promise((resolve, reject) => {
      this.service
        .patchDataV2(endpoint, data)
        .then((res: any) => {
          if (res.data.code == 200 && res.data.status == "success") {
            this.service.showSuccess("Service data updated successfully");
            resolve({ isSuccess: true });
          } else {
            this.service.showError("Error updating service data");
            reject({ isSuccess: false });
          }
        })
        .catch((err) => {
          this.service.showError("Error updating service data");
          reject({ isSuccess: false });
        });
    });
  }

  // TO INSERT SERVICE RECORD AS WELL AS GREASING RECORD 
  insertData(endpoint,data) {
    return new Promise((resolve, reject) => {
      this.service
       .postData(endpoint, data)
       .then((res: any) => {
          if (res.data.code == 200 && res.data.status == "success") {
            this.service.showSuccess("Service Data Inserted Successfully");
            resolve({ isSuccess: true });
          } else {
            this.service.showError("Error Inserting Service Data");
            reject({ isSuccess: false });
          }
        })
       .catch((err) => {
          this.service.showError("Error Inserting Service Data");
          reject({ isSuccess: false });
        });
    });
  }
}
